import styled from "styled-components";
import { Widget } from "../../../../components/widget";
import { device } from "../../../../styles/media";

export const StyledWidget = styled(Widget)``;

export const Container = styled.form`
  padding: 1em 0;

  @media ${device.laptop} {
    overflow: auto;
  }
`;

export const FieldSection = styled.div`
  &:not(:last-child) {
    margin-bottom: 3em;
  }
`;

export const FieldSubSection = styled.div`
  &:not(:last-child) {
    margin-bottom: 1.4em;
  }
`;

export const SectionTitle = styled.div`
  font-size: 1.4em;
  font-weight: 700;
`;
